<template>
    <div class="container">
          <div class="wrap">
            <video :src="videoPath" playsinline autoplay loop></video>
            <!-- <div class="id">任务id:{{id}}</div> -->
          </div>
      </div>
  </template>
  <script>
  import { getInfo } from '@/api/user';
      export default {
        name:'videoLoad',
          data() {
              return {
                videoPath: '',
                video1:require('@/assets/loading.mp4'),
                video2:require('@/assets/fitting.mp4'),
                status:'',
                timer:null,
                isCompleted: false,
                id:localStorage.getItem('taskId'),
              }
          },
          methods: {
            getInfo(){
              getInfo({id:localStorage.getItem('taskId')}).then((res) => {
                if (res.code === 1) {
                  this.isCompleted = res.data.status == 2? true : false;
                  if(this.isCompleted){
                    clearInterval(this.timer)
                    this.$router.push({ path: '/myDimension'})
                  }
                }
              });
            }
          },
          created() {
            let status = this.$route.params.status;
            if(status === 'dimension'){
              this.videoPath = this.video1;
              setTimeout(() => {
                    this.$router.push({ path: '/myDimension'})
                }, 4500);
              // this.timer = setInterval(() => {
              //   this.getInfo()
              // }, 2000);
            }else if(status === 'fitting'){
                this.videoPath = this.video2;
                setTimeout(() => {
                    this.$router.push({ path: '/aiEffect'})
                }, 4500);
            }
            this.status = status
            
          },
          // 例如这个函数就会在组件挂载完成后被调用
          mounted() {

          }
      }
</script>
<style src="" scoped lang="less">
   video {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover; /* 保持视频比例并铺满屏幕 */
    z-index: -1; /* 如果需要将视频作为背景，可以设置 z-index */
   }
   .id{
    position: fixed;
    top: 10rem;
    left:0;
    z-index: 9;
    color: #000;
    font-size: 1rem;
    text-align: center;
    width: 100%;
   }
</style>